// src/index.tsx
import { Navigate, Route, Routes } from 'react-router-dom';
import AudioMeter from '../../DecibelMeter/AudioMeter/AudioMeter';
import Home from '../Home/Home';
import './Routing.css';
import { About } from '../About/About';
export function Routing(): JSX.Element {
    const handleDbChange = (db: number) => {
        // Handle the db change here
        console.log('Decibel level changed:', db);
    };

    return (
        <div className="Routing">
            <Routes>
                <Route path="/" element={<Navigate to="/home" />} />
                <Route path="/home" element={<Home />} />
                <Route path="/meter" element={<AudioMeter onDbChange={handleDbChange} />} />
                <Route path="/about" element={<About />} />
            </Routes>
        </div>
    );
}